export default __webpack_public_path__ + "static/media/notifications_5.77ab2722.png";